import screenfull from 'screenfull'

function toggleFullscreen() {
	screenfull.toggle(document.documentElement)
}

export default toggleFullscreen
